/* Manages the session-local order status list used by the compact mobile shell. */
import {type MobileOrderSubmission} from './mobile-order-types.js';

export const maxMobileSessionOrders = 100;

/** Sorts mobile order submissions newest-first without mutating React state. */
export function sortMobileOrdersNewestFirst(orders: MobileOrderSubmission[]): MobileOrderSubmission[] {
  return [...orders].sort((left, right) => new Date(right.timestamp).getTime() - new Date(left.timestamp).getTime());
}

/** Inserts or replaces a submitted order while capping the session list size. */
export function upsertMobileSessionOrder(
  orders: MobileOrderSubmission[],
  order: MobileOrderSubmission,
  maxOrders = maxMobileSessionOrders,
): MobileOrderSubmission[] {
  return [order, ...orders.filter(candidate => candidate.clientId !== order.clientId)].slice(0, maxOrders);
}
